import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyDWKZXRBYubmCFEx4Y-K_vLx73l71OU_J4",
  authDomain: "affitrack-d6a5e.firebaseapp.com",
  projectId: "affitrack-d6a5e",
  storageBucket: "affitrack-d6a5e.firebasestorage.app",
  messagingSenderId: "451747409712",
  appId: "1:451747409712:web:02258689b9a7596f0162f5"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
